export default __webpack_public_path__ + "static/media/meals.d8ec17ff.jpg";